export default __webpack_public_path__ + "landingPageBasrus.html";